import type { QuoteLanguage } from "@/types"

/**
 * Multilingual treatment/category text as stored in the catalog JSON columns.
 * en/it/al/es are seeded; fr/de may be absent (quote languages added before
 * catalog translations existed) — callers always fall back to English.
 */
export interface TreatmentLocaleText {
  en?: string
  it?: string
  al?: string
  es?: string
  fr?: string
  de?: string
}

/**
 * Frontend mirror of the backend getTranslatedName() helpers
 * (TreatmentCatalogItem / TreatmentCategory / QuoteItem models):
 * selected quote language first, English fallback.
 */
export function localizedTreatmentText(
  text: TreatmentLocaleText | null | undefined,
  language: QuoteLanguage,
): string {
  if (!text) return ""
  return text[language] || text.en || ""
}
